/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StationSecurityFilesList } from '../../models/station-security-files-list';

export interface GetStationSecurityFileslist$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
}

export function getStationSecurityFileslist(http: HttpClient, rootUrl: string, params: GetStationSecurityFileslist$Params, context?: HttpContext): Observable<StrictHttpResponse<StationSecurityFilesList>> {
  const rb = new RequestBuilder(rootUrl, getStationSecurityFileslist.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StationSecurityFilesList>;
    })
  );
}

getStationSecurityFileslist.PATH = '/custom/station/{uid}/SecurityFile/getFilesList';
